<template>
    <v-card v-if="assessmentResults">
        <v-card-title primary-title class="justify-center">
            <div>
                <h3 class="display-1">Test Results</h3>
                <h3>Completed on {{assessmentResults.timestamp.toLocaleString()}}</h3>
                <v-divider></v-divider>
                <h3>{{assessmentResults.countPercentageCorrect()}}%</h3>
            </div>

            <AssessmentHistoryChart
                    :studentId="studentId"
                    :maxNumEntries="4"
            ></AssessmentHistoryChart>
        </v-card-title>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info"
                   @click="navigateToStudentHistory()">More History &gt;&gt;</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import AssessmentHistoryChart from '@/views/AssessmentHistoryChart.vue';

    export default {
        name: "AssessmentSummary",
        components: {AssessmentHistoryChart},
        data: function() {
            return {
                studentId: undefined,
                assessmentResults: undefined
            };
        },
        methods: {
            navigateToStudentHistory() {
                this.$router.push({
                    name: 'test-history-chart',
                    query: {
                        studentId: this.studentId
                    }
                })

            }
        },
        mounted() {
            // get assessment and student data
            this.$store.dispatch('getHistory', {
                ids: [+this.$router.currentRoute.params['historyId']]
            }).then(hList => {
                if (!hList || !hList.length) {
                    return Promise.reject('Requested history entry wasn\'t found');
                }
                this.assessmentResults = hList[0];
                this.studentId = hList[0].studentId;
            }).then(() =>
                // we got the history entry, now get student ID and assessment ID to make a title for toolbar
                Promise.all([
                    this.$store.dispatch('getAssessments', {
                        ids: [this.assessmentResults.assessmentId]
                    }),
                    this.$store.dispatch('getStudents', {
                        ids: [this.assessmentResults.studentId]
                    })])
                    .then((results) => {
                        if (!results || results.length !== 2) {
                            return Promise.reject('Unable to get student and/or test information');
                        }
                        let aList = results[0];
                        let sList = results[1];

                        if (!aList || !aList.length) {
                            return Promise.reject('Requested test wasn\'t found');
                        }
                        if (!sList || !sList.length) {
                            return Promise.reject('Requested student wasn\'t found');
                        }
                        let assessment = aList[0];
                        let student = sList[0];

                        let title = (assessment && assessment.title ? assessment.title : 'Unknown assessment');
                        let subTitle = (student && student.getFullName ? student.getFullName() : 'unknown student');
                        // set toolbar title
                        this.$store.commit('setToolbarOptions', {
                            title: title,
                            subTitle: subTitle,
                            hideSearch: true,
                            backButtonRoute: {name: 'test', params: {id: assessment.assessmentId}}
                        });
                    }));
        }
    }
</script>

<style scoped>

</style>
